import retry from '@blockcatio/tabby-library/lib/utilities/retry';

import {
  APP_INIT,
  APP_SHUTDOWN,
  PAY_WITH_ETH_FEE_UPDATED,
  PAY_WITH_ETH_FEE_UPDATE_FAILED,
  PAY_WITH_CAT_FEE_UPDATED,
  PAY_WITH_CAT_FEE_UPDATE_FAILED,
  LATEST_BLOCK_NUMBER_UPDATED,
  LATEST_BLOCK_NUMBER_UPDATE_FAILED,
  RECOMMENDED_GAS_PRICES_UPDATE,
  RECOMMENDED_GAS_PRICES_UPDATE_FAILED,
} from '../actionTypes';

const doAppInit = (
  payContractAddress,
  catPaymentContractAddress,
  catTokenContractAddress,
  defaultTokenList,
  gasLimits,
) => ({
  type: APP_INIT,
  payContractAddress,
  catPaymentContractAddress,
  catTokenContractAddress,
  defaultTokenList,
  gasLimits,
});

export const appShutdown = () => ({
  type: APP_SHUTDOWN,
});

export const appInit = appProps => async (
  dispatch,
  getState,
  {
    eth, tabbyPay, catToken, errorReporter,
  },
) => {
  dispatch(doAppInit(
    appProps.payContractAddress,
    appProps.catPaymentContractAddress,
    appProps.catTokenContractAddress,
    appProps.tokenList,
    appProps.gasLimits,
  ));
  try {
    const allAddresses = await retry(() =>
      tabbyPay.fetchFromAll(
        instance => instance.getAddress(),
        addresses =>
          addresses
            .reduce((out, address) => out.concat([address]), [catToken.tokenContractAddress])
            .filter(address => address),
      ));

    const validContracts = await Promise.all(allAddresses.map(async (address) => {
      const isContract = await eth.isAddressValidContract(address);
      return [address, isContract];
    }));

    validContracts.forEach(([address, isContract]) => {
      if (!isContract) {
        throw new Error(`App misconfigured: contract not found at ${address}`);
      }
    });
  } catch (error) {
    errorReporter(error);
  }
};

export const appRenderError = (error, extraInfo) => async (
  dispatch,
  getState,
  { errorReporter },
) => {
  errorReporter(error, extraInfo);
};

export const payWithEthFeeUpdated = fee => ({
  type: PAY_WITH_ETH_FEE_UPDATED,
  fee,
});

export const payWithEthFeeUpdateFailed = error => ({
  type: PAY_WITH_ETH_FEE_UPDATE_FAILED,
  error,
});

export const payWithCatFeeUpdated = fee => ({
  type: PAY_WITH_CAT_FEE_UPDATED,
  fee,
});

export const payWithCatFeeUpdateFailed = error => ({
  type: PAY_WITH_CAT_FEE_UPDATE_FAILED,
  error,
});

export const latestBlockNumberUpdated = blockNumber => ({
  type: LATEST_BLOCK_NUMBER_UPDATED,
  blockNumber,
});

export const latestBlockNumberUpdateFailed = error => ({
  type: LATEST_BLOCK_NUMBER_UPDATE_FAILED,
  error,
});

export const fetchRecommendedGasPricesUpdate = recommendedGasPrices => ({
  type: RECOMMENDED_GAS_PRICES_UPDATE,
  recommendedGasPrices,
});

export const fetchRecommendedGasPricesUpdateFailed = error => ({
  type: RECOMMENDED_GAS_PRICES_UPDATE_FAILED,
  error,
});



// WEBPACK FOOTER //
// ./src/actions/app.js